"use client"

import clsx from "clsx"

import FilterCheckbox, { type FilterCheckboxProps } from "~/components/ui/FilterCheckbox"

import * as css from "./styles.css"

export function SwatchCheckbox({
  colorHexadecimal,
  name,
  value,
  selected,
  ...props
}: FilterCheckboxProps & {
  colorHexadecimal?: string
  selected?: boolean
}) {
  if (!value || typeof value !== "string" || !name) return null

  const { label, defaultChecked } = props

  return (
    <FilterCheckbox
      {...props}
      checkmarkActive={null}
      contentClassName={css.swatch}
      inputClassName={css.swatchInput}
      checkmarkClassName={clsx(css.swatchCheckmark, { [css.selected]: selected || defaultChecked })}
      labelClassName={css.swatchLabel}
      name={name}
      value={value}
      id={value}
    >
      {colorHexadecimal && <i className={css.swatchImage} style={{ backgroundColor: colorHexadecimal }}></i>}
      {label || value}
    </FilterCheckbox>
  )
}
